<button
  mat-icon-button
  type="button"
  class="mdr-close-button"
  aria-label="Close"
  (click)="close()">
  <mat-icon>close</mat-icon>
</button>

<h2 mat-dialog-title>
  Change request: {{ data.booking_number }} {{ data.passenger_name }}
</h2>

<mat-dialog-content>

  @if (data.detached_cabins && data.detached_cabins.length > 0) {
    <div class="mdr-detached-warning">
      <mat-icon>error_outline</mat-icon>
      <span>Cabins detached from the original reservation: {{ data.detached_cabins.join(', ') }}</span>
    </div>
  }

  <p class="mdr-total-diners"><strong>Total diners: {{ data.total_diners }}</strong></p>

  <table mat-table [dataSource]="data.passengers" class="mdr-passengers-table">

    <ng-container matColumnDef="relation">
      <th mat-header-cell *matHeaderCellDef>Relation</th>
      <td mat-cell *matCellDef="let row">{{ relationLabel(row.relation) }}</td>
    </ng-container>

    <ng-container matColumnDef="booking_number">
      <th mat-header-cell *matHeaderCellDef>Booking Number</th>
      <td mat-cell *matCellDef="let row">{{ row.booking_number }}</td>
    </ng-container>

    <ng-container matColumnDef="cabin">
      <th mat-header-cell *matHeaderCellDef>Cabin</th>
      <td mat-cell *matCellDef="let row">
        <span
          class="mdr-cabin"
          [matTooltip]="row.occupant_name || ''"
          matTooltipPosition="above">
          {{ row.cabin }}
          @if (row.occupant_name) {
            <mat-icon class="mdr-cabin-info-icon">info_outline</mat-icon>
          }
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="dining_with_code">
      <th mat-header-cell *matHeaderCellDef>Dining with code</th>
      <td mat-cell *matCellDef="let row">{{ row.dining_with_code }}</td>
    </ng-container>

    <ng-container matColumnDef="language">
      <th mat-header-cell *matHeaderCellDef>Language</th>
      <td mat-cell *matCellDef="let row">{{ row.language }}</td>
    </ng-container>

    <ng-container matColumnDef="passenger_name">
      <th mat-header-cell *matHeaderCellDef>Passenger Name</th>
      <td mat-cell *matCellDef="let row">{{ row.passenger_name }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let row">
        <span [class]="'mdr-status mdr-status-' + row.status.toLowerCase()">
          {{ statusLabel(row.status) }}
        </span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

  </table>

</mat-dialog-content>
